<template>
	<b-modal
		v-model="viewNotes"
		id="viewnote"
		centered
		hide-footer
		:title="!editNotes ? 'View Note' : 'Edit Note'"
		size="lg"
		no-close-on-backdrop
	>
		<section class="position-absolute viewimage-header-icons mr-2">
			<img
				v-if="!editNotes && $route.name !== 'coursecreation'"
				@click="$emit('changeVal', 'editNotes')"
				src="@/assets/common/edit.svg"
				v-b-modal.editnote
				alt=""
				class="mr-2 pointer"
			/><img
				v-if="!editNotes && $route.name !== 'coursecreation'"
				@click="$emit('changeVal', 'delete', 'viewNotes')"
				src="@/assets/common/delete.svg"
				alt=""
				class="mr-2 pr-2 ab-right-line pointer"
			/>
			<img
				@click="$emit('closeModal', 'viewNotes')"
				class="rotate-on-hover"
				src="@/assets/common/blue-cross.svg"
				alt=""
			/>
		</section>

		<section class="p-3" v-if="!editNotes">
			<div class="header-container mb-3" style="background: #eef3f7">
				<h1 class="fw-500">{{ showDetails.title }}</h1>
			</div>
			<div class="d-flex gap-2 flex-wrap">
				<div
					class="ab-lv-tags"
					v-for="(tag, index) in showDetails.tags"
					:key="index"
				>
					#{{ tag }}
				</div>
			</div>

			<ol class="en-list-desc mt-4">
				<span v-html="showDetails.notes"></span>
			</ol>
		</section>
		<section class="py-1 px-2" v-else>
			<Notes
				:notesData="showDetails"
				:validation="validation"
				:editNotes="editNotes"
			/>
		</section>
		<hr v-if="editNotes" />
		<div
			class="d-flex justify-content-end align-items-center px-3 pb-3"
			v-if="editNotes"
		>
			<OButton
				class="p1-15"
				@clicked="$emit('closeModal', 'viewNotes')"
				text="Cancel"
			/>
			<PButton
				:loading="loading"
				widthClass="button-width"
				class="ml-2 p1-15"
				text="Update"
				@clicked="$emit('handle-save')"
			/>
		</div>
	</b-modal>
</template>
<script>
import Notes from "./Note.vue";
export default {
	props: {
		viewNotes: Boolean,
		showDetails: Object,
		editNotes: Boolean,
		validation: Object,
		loading: Boolean,
	},
	components: {
		Notes,
	},
};
</script>
